import { Reveal, MaskLines } from "@/components/Motion";
import { CallButton, ConsultButton } from "@/components/Buttons";
import { PHONE } from "@/data/site";
import { LogoMark } from "@/components/Logo";

export const CTABand = ({ title = ["Leaving Town?", "Let Us Help You Keep", "an Eye on Home."], text, consultLabel = "Schedule a Free Consultation", testId = "cta-band" }) => (
  <section data-testid={testId} className="grain relative overflow-hidden bg-[#A52A32] py-20 text-white md:py-28">
    <LogoMark className="pointer-events-none absolute -right-20 -top-10 h-[28rem] w-[28rem] opacity-[0.08] md:h-[36rem] md:w-[36rem]" />
    <div className="relative mx-auto grid max-w-[1400px] gap-10 px-5 md:px-10 lg:grid-cols-12 lg:items-end">
      <div className="lg:col-span-8">
        <h2 className="font-display text-4xl font-semibold leading-[1.02] sm:text-5xl lg:text-7xl">
          <MaskLines lines={title} onView />
        </h2>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/90 md:text-lg">
            {text || "Whether you're a seasonal resident or frequent traveler, we would welcome the opportunity to discuss your property and service needs."}
          </p>
        </Reveal>
      </div>
      <Reveal delay={0.3} className="flex flex-col gap-4 lg:col-span-4 lg:items-end">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/85">Call Dwight at</p>
        <a href="tel:5617223224" data-testid={`${testId}-phone`} className="font-display text-4xl font-semibold hover:underline md:text-5xl">{PHONE}</a>
        <div className="flex flex-wrap gap-3">
          <ConsultButton testId={`${testId}-consult-btn`} label={consultLabel} dark className="!bg-[#14263D]" />
          <CallButton testId={`${testId}-call-btn`} dark label="Call Now" />
        </div>
      </Reveal>
    </div>
  </section>
);
